import { FileSpreadsheet, FileText, Loader2, Presentation, X } from 'lucide-react'
import { isAssistantImageMime, type AssistantAttachmentView } from '@repo/types'
import { formatBytes } from '@/lib/utils'
import type { PendingAttachment } from './useAssistantAttachments'

function FileIcon({ mimeType, className }: { mimeType: string; className: string }) {
  if (mimeType.includes('spreadsheet')) return <FileSpreadsheet className={className} />
  if (mimeType.includes('presentation')) return <Presentation className={className} />
  return <FileText className={className} />
}

/** Prílohy rozpísanej správy nad poľom na písanie. */
export function ComposerAttachments({ items, onRemove }: { items: PendingAttachment[]; onRemove: (localId: string) => void }) {
  if (items.length === 0) return null
  return (
    <ul className="mb-2 flex flex-wrap gap-2">
      {items.map((item) => (
        <li key={item.localId} className="flex max-w-full items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 py-1 pl-1 pr-1.5 text-xs dark:border-gray-600 dark:bg-gray-700">
          {!item.view ? (
            <Loader2 className="h-8 w-8 shrink-0 animate-spin p-2 text-gray-400" />
          ) : isAssistantImageMime(item.view.mimeType) ? (
            <img src={item.view.url} alt="" className="h-8 w-8 shrink-0 rounded object-cover" />
          ) : (
            <FileIcon mimeType={item.view.mimeType} className="h-8 w-8 shrink-0 p-1.5 text-gray-500 dark:text-gray-300" />
          )}
          <span className="min-w-0">
            <span className="block max-w-[180px] truncate text-gray-800 dark:text-gray-100">{item.filename}</span>
            <span className="text-gray-500 dark:text-gray-400">{item.view ? formatBytes(item.sizeBytes) : 'Nahrávam…'}</span>
          </span>
          <button type="button" className="rounded p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-700 dark:hover:bg-gray-600 dark:hover:text-gray-100" aria-label={`Odstrániť ${item.filename}`} onClick={() => onRemove(item.localId)}>
            <X className="h-3.5 w-3.5" />
          </button>
        </li>
      ))}
    </ul>
  )
}

/** Prílohy odoslanej správy v bubline používateľa — klik otvorí súbor v novej karte. */
export function BubbleAttachments({ attachments }: { attachments: AssistantAttachmentView[] }) {
  return (
    <div className="mb-1 flex flex-col items-end gap-1.5">
      {attachments.map((a) =>
        isAssistantImageMime(a.mimeType) ? (
          <a key={a.id} href={a.url} target="_blank" rel="noreferrer" title={a.filename}>
            <img src={a.url} alt={a.filename} className="max-h-40 max-w-full rounded-lg object-cover" />
          </a>
        ) : (
          <a key={a.id} href={a.url} target="_blank" rel="noreferrer" className="flex max-w-full items-center gap-1.5 rounded-lg bg-white/15 px-2 py-1 text-xs hover:bg-white/25">
            <FileIcon mimeType={a.mimeType} className="h-4 w-4 shrink-0" />
            <span className="truncate">{a.filename}</span>
          </a>
        ),
      )}
    </div>
  )
}
